import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import VisibilityIcon from '@material-ui/icons/Visibility';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import { makeStyles } from '@material-ui/core/styles';

import { push } from 'connected-react-router';

import Dialog from './dialog';

const useStyles = makeStyles((theme) => ({
  icon: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
}));

export const Actions = ({ push, value, ...props }) => {
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  return (
    <>
      <Button
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        &bull;&bull;&bull;
      </Button>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={() => push(`/distributor/car/view/${value}`)}>
          <VisibilityIcon className={classes.icon} />
          <FormattedMessage id="Ver" />
        </MenuItem>
        {/*         <MenuItem onClick={handleOpenDialog}>
          <MailOutlineIcon className={classes.icon} />
          <FormattedMessage id="Denunciar RUN" />
        </MenuItem> */}
        <MenuItem onClick={handleOpenDialog}>
          <MailOutlineIcon className={classes.icon} />
          <FormattedMessage id="Volver a enviar cert de garantía" />
        </MenuItem>
      </Menu>
      {openDialog && (
        <Dialog open={openDialog} onClose={handleCloseDialog} code={value} />
      )}
    </>
  );
};

export default connect(undefined, { push })(Actions);
